import { EmployeesByDayFragment } from 'generated/resources/graphql'
import { computed, makeObservable } from 'mobx'

import CoverageByDay from 'modules/shift_management/store/internal/models/CoverageByDay'

class CoveragesByDay {
  coveragesByDay: CoverageByDay[]

  constructor(coveragesByDay: CoverageByDay[]) {
    this.coveragesByDay = coveragesByDay

    makeObservable(this, {
      _groupByDate: computed,
    })
  }

  /**
   * Transforms an array of objects from a request into an array of
   * Coverages By Day objects
   */
  static buildFromRequest(coveragesByDay: EmployeesByDayFragment[]): CoveragesByDay {
    const coveragesByDayObjects = coveragesByDay.map((coverageByDay) =>
      CoverageByDay.buildFromRequest(coverageByDay)
    )

    return new CoveragesByDay(coveragesByDayObjects)
  }

  get _groupByDate(): Record<string, CoverageByDay> {
    return this.coveragesByDay.reduce((result: Record<string, CoverageByDay>, coveragesByDay) => {
      result[coveragesByDay.date.format('YYYY-MM-DD')] = coveragesByDay
      return result
    }, {})
  }

  getNumberOfEmployees(date: moment.Moment): number {
    return this._groupByDate[date.format('YYYY-MM-DD')]?.numberOfEmployees || 0
  }
}

export default CoveragesByDay
